<div class="player-hero card flex flex-wrap items-center justify-between gap-4">
    <div class="flex items-center gap-4">
        <div class="avatar-wrap">
            @if (avatarUrl) {
                <img [src]="avatarUrl" alt="Avatar" class="avatar-img" />
            } @else {
                <i class="pi pi-user avatar-placeholder"></i>
            }
        </div>

        <div>
            <div class="text-sm uppercase tracking-wider opacity-80">Ligafahrer</div>
            <div class="text-3xl font-bold">{{ name }}</div>
            @if (psn) {
                <div class="opacity-80">PSN: {{ psn }}</div>
            }
            @if (discord) {
                <div class="opacity-80">Discord: {{ discord }}</div>
            }
        </div>
    </div>

    <div class="player-devices">
    @if (controllerType) {
        <div class="player-controller">
            <div class="controller-visual">
                @switch (controllerType) {
                    @case ('wheel') {
                        <!-- Steering wheel -->
                        <svg class="controller-svg" viewBox="0 0 24 24" fill="none" aria-label="Lenkrad">
                            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
                            <circle cx="12" cy="12" r="2.4" fill="currentColor" />
                            <path
                                d="M12 14.4V21 M9.9 11 4.2 8.4 M14.1 11 19.8 8.4"
                                stroke="currentColor"
                                stroke-width="1.6"
                                stroke-linecap="round"
                            />
                            <path
                                d="M4.6 16.5a8.7 8.7 0 0 0 14.8 0"
                                stroke="currentColor"
                                stroke-width="1.6"
                                stroke-linecap="round"
                            />
                        </svg>
                    }
                    @case ('controller') {
                        <!-- Gamepad -->
                        <svg class="controller-svg" viewBox="0 0 24 24" fill="currentColor" aria-label="Controller">
                            <path
                                d="M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                            />
                        </svg>
                    }
                }
            </div>

            <div class="controller-meta">
                <div class="text-sm uppercase tracking-wider opacity-80">Eingabegerät</div>
                <div class="font-semibold">{{ controllerLabel }}</div>
            </div>
        </div>
    }

    @if (displayDevice) {
        <div class="player-display">
            <div class="display-visual">
                <app-display-device-icon [type]="displayDevice" size="3rem" />
            </div>

            <div class="display-meta">
                <div class="text-sm uppercase tracking-wider opacity-80">Ausgabegerät</div>
                <div class="font-semibold">{{ displayDeviceLabel }}</div>
            </div>
        </div>
    }
    </div>
</div>
